import { render } from "./FactoryAPIToken.vue?vue&type=template&id=4772449e"
import script from "./FactoryAPIToken.vue?vue&type=script&lang=js"
export * from "./FactoryAPIToken.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__